import { ProgramThumbnailGroupItem } from '@type/buzzkuri/program-detail'
import { ProgramsSlideContentContainer } from './ContentContainer'
import { ProgramsSlideContentItem } from './Item'

type Peops = {
  idx: number
  programThumbnailGroup: ProgramThumbnailGroupItem[]
  translateX: number
}

export const ProgramsSlideContent = ({
  programThumbnailGroup,
  idx,
  translateX,
}: Peops): JSX.Element => {
  return (
    <ProgramsSlideContentContainer {...{ idx, translateX }}>
      <>
        {programThumbnailGroup.map((programThumbnailGroupItem, i) => (
          <div key={i} className="flex flex-col mr-[1.6vw] last:mr-0">
            <ProgramsSlideContentItem {...programThumbnailGroupItem} />
          </div>
        ))}
      </>
    </ProgramsSlideContentContainer>
  )
}
